import React from 'react';
import {
  Edit,
  TabbedForm,
  FormTab,
  TextInput,
  SelectInput,
  NumberInput,
  BooleanInput,
  DateTimeInput,
  ReferenceInput,
  required,
  FunctionField,
} from 'react-admin';

const orderStatusChoices = [
  { id: 'pending', name: 'Ожидает' },
  { id: 'processing', name: 'Обрабатывается' },
  { id: 'shipped', name: 'Отправлен' },
  { id: 'delivered', name: 'Доставлен' },
  { id: 'cancelled', name: 'Отменен' },
];

export const OrderEdit = () => (
  <Edit>
    <TabbedForm>
      <FormTab label="Основная информация">
        <TextInput source="id" label="ID заказа" disabled />
        
        <ReferenceInput source="userId" reference="users" label="Клиент">
          <SelectInput optionText="name" validate={[required()]} />
        </ReferenceInput>
        
        <ReferenceInput source="supplementId" reference="supplements" label="Добавка">
          <SelectInput optionText="name" validate={[required()]} />
        </ReferenceInput>
        
        <NumberInput source="quantity" label="Количество" validate={[required()]} min={1} />
        <NumberInput source="totalPrice" label="Общая сумма ($)" step={0.01} validate={[required()]} />
      </FormTab>

      <FormTab label="Статус и оплата">
        <SelectInput 
          source="status" 
          choices={orderStatusChoices} 
          validate={[required()]} 
          label="Статус заказа" 
        />
        
        <BooleanInput source="isPaid" label="Заказ оплачен" />
        <DateTimeInput source="paidAt" label="Дата оплаты" />
      </FormTab>

      <FormTab label="Контекст и рекомендации">
        <TextInput 
          source="challengeContext" 
          label="Контекст челленджа" 
          multiline 
          rows={3} 
        />
        <TextInput 
          source="recommendationReason" 
          label="Причина рекомендации" 
          multiline 
          rows={3} 
        />
      </FormTab>

      <FormTab label="Доставка">
        <TextInput 
          source="shippingAddress" 
          label="Адрес доставки (JSON)" 
          multiline 
          rows={4} 
        />
        <TextInput 
          source="trackingInfo" 
          label="Информация о трекинге (JSON)" 
          multiline 
          rows={4} 
        />
      </FormTab>

      <FormTab label="Системная информация">
        <FunctionField 
          label="Дата создания"
          render={(record: any) => new Date(record.createdAt).toLocaleString()}
        />
        <FunctionField 
          label="Дата обновления"
          render={(record: any) => new Date(record.updatedAt).toLocaleString()}
        />
      </FormTab>
    </TabbedForm>
  </Edit>
);





